import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentAppPage on AppPage {
    id
    alias
    pageId
    name
    description
    display {
      isMain
      position
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentAppPageFragment,
  ents.core.admin.App.Page
>({
  alias: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  description: transformers.PASS_THROUGH,
  display: graphql.transformers.OUT.object({
    isMain: graphql.transformers.OUT.validate(
      transformers.PASS_THROUGH,
      TypeAsserter.assertIsNotNullish,
      { warnOnly: true },
    ),
    position: graphql.transformers.OUT.validate(
      transformers.PASS_THROUGH,
      TypeAsserter.assertIsNotNullish,
      { warnOnly: true },
    ),
  }),
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  name: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  pageId: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  // TODO: Variables should be implemented
  variables: () => ({}),
})
